import { Component } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { AuthService } from '../../_services/index'
import 'rxjs/add/operator/map'
import * as _ from 'underscore'
import { LoaderService } from 'app/_services/loader.service'
import * as _moment from 'moment'
import * as _rollupMoment from 'moment'
const moment = _rollupMoment || _moment
import { environment } from 'environments/environment'
import { process, State } from '@progress/kendo-data-query'
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query'
import {
  GridDataResult,
  DataStateChangeEvent,
} from '@progress/kendo-angular-grid'
import { Observable } from 'rxjs/Observable'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'

declare var $: any

import { UccUsersService } from '../../reports/uccReport/uccUsers.service'
import { UccPermsService } from './UccPerms.service'
import { uccUsers } from '../../reports/uccReport/uccUsers.model'
import {
  AngularFirestore,
  AngularFirestoreDocument,
  AngularFirestoreCollection,
} from 'angularfire2/firestore'
@Component({
  selector: 'ucc-user',
  templateUrl: './uccUser.component.html',
})
export class UccUserComponent {
  filterData: any
  setWardSuccess: any
  setDenoSuccess: any
  setPermsSuccess: any
  Employeedata: any
  search: any
  prjId: any
  userId: any
  showLoader: any
  collectionList: any
  dataRangeModal: any
  startDate: any
  endDate: any
  defaultStartDate: any
  defaultEndDate: any
  uccMobileUserList: any
  dateLink: any
  geocoder: any
  uccRecardStatus = false
  address: any
  // public editor: any
  // public container: any
  // public options: any
  public userPermList: any
  public userMobileNo: any
  jsonObject: any
  parshJson: any
  zoneList: any
  wardList: any
  userFBID: any
  userName: any
  deviceId: any
  vehMaintDoc: AngularFirestoreDocument<uccUsers>
  jsonData: uccUsers
  wardName: string
  wardID: string
  strfData: any
  prjs
  prjName: any
  userData: any
  prjActiveStatus: any
  zoneSelect: string
  zoneName: string
  wardSelect: string
  kccZoneActiveStatus: boolean
  denominations = []
  uccZones = []
  uccBlankZones = []
  amt: any
  amtActive: any
  addAmount: any
  addActive: any
  kccZones = []
  kccZoneSelect: any
  newKccZone: { ZONEID: any; ZONENAME: any }
  newUccZone: { ZONEID: string; ZONENAME: any; wards: any[] }
  wards: any[]
  newPrjID: any
  selectedUccZones: any[]
  uccWards = []
  loading: boolean = true
  kccPrjName: string
  kccZoneList: any

  public state: State = {
    skip: 0,
    take: 15,
    filter: {
      logic: 'and',
      filters: [],
    },
  }
  public gridDataCouponCollection: GridDataResult
  public groups: GroupDescriptor[] = []
  public view: Observable<GridDataResult>
  public gridView: DataResult
  wmUser: string
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups
    this.loadProducts()
  }
  private loadProducts(): void {
    this.gridDataUserList = process(this.uccMobileUserList, {
      group: this.groups,
    })
  }
  public gridDataUserList: GridDataResult
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.uccMobileUserList,
    }
    return result
  }

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    public afs: AngularFirestore,
    private loaderService: LoaderService,
    private _ucc: UccUsersService,
    private uccPerms: UccPermsService,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
      this.allData = this.allData.bind(this)
      this.prjs = [
        { id: 1, name: 'LUCKNOW' },
        { id: 2, name: 'GURUGRAM' },
        { id: 3, name: 'FARIDABAD' },
        { id: 4, name: 'GWLIOR' },
      ]
    })

    this.filterData = {}
    var firstDay = new Date()
    var lastDay = new Date()
    this.defaultStartDate =
      firstDay.getFullYear() +
      '-' +
      (firstDay.getMonth() + 1) +
      '-' +
      firstDay.getDate()
    this.defaultEndDate =
      firstDay.getFullYear() +
      '-' +
      (firstDay.getMonth() + 1) +
      '-' +
      firstDay.getDate()
    this.dataRangeModal = {
      beginDate: {
        year: firstDay.getFullYear(),
        month: firstDay.getMonth() + 1,
        day: firstDay.getDate(),
      },
      endDate: {
        year: lastDay.getFullYear(),
        month: lastDay.getMonth() + 1,
        day: lastDay.getDate(),
      },
    }
    $('#save-loader').hide()
  }

  /*
   * GET UCC RECEIPT REPORT
   */
  getUccUserReport() {
    this.loaderService.display(true)
    this.http
      .get(environment.apiUrl + 'uccnew/uccUsersReport?prjid=' + this.prjId)
      .subscribe((data) => {
        this.uccMobileUserList = data

        console.log('this.uccMobileUserList', this.uccMobileUserList)

        if (this.uccMobileUserList.length > 0) {
          this.loaderService.display(false)
          this.uccRecardStatus = false
          this.gridDataUserList = process(this.uccMobileUserList, this.state)
        } else {
          this.uccRecardStatus = true
          this.loaderService.display(false)
          this.gridDataUserList = process(this.uccMobileUserList, this.state)
        }
      })
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state
    this.gridDataUserList = process(this.uccMobileUserList, this.state)
    if (state && state.group) {
      this.gridDataUserList = process(this.uccMobileUserList, this.state)
    }
  }

  clearFields() {
    this.setPermsSuccess = false
    this.userMobileNo = null
    this.userFBID = null
    this.userName = null
    this.deviceId = null
    this.prjName = null
    this.prjActiveStatus = null
    this.zoneSelect = null
    this.uccZones = null
    this.denominations = null
  }

  refresh() {
    this.http
      .get(environment.apiUrl + 'uccnew/uccUsersReport')
      .subscribe((data) => {})
  }

  removeKccZone(data) {
    this.removeByAttr(this.kccZones, 'ZONEID', data.ZONEID)
  }

  removeZone(data) {
    this.removeByAttr(this.uccZones, 'ZONEID', data.ZONEID)
  }

  removeWard(data) {
    this.removeByAttr(this.uccWards, 'WARDID', data.WARDID)
  }

  /*
   * View and Edit Permission
   */
  setPermission(userData) {
    $('#save-loader').hide()
    this.clearFields()
    var userObj = { kcc_permissions: {}, ucc_permissions: {} }
    var kccZones

    userObj.kcc_permissions = userData.kcc_permissions
    userObj.ucc_permissions = userData.ucc_permissions
    this.userData = userData
    // var strfData = JSON.stringify(userObj)
    // this.strfData = strfData
    // this.editor.set(JSON.parse(strfData));
    this.userMobileNo = userData.mobile
    this.userFBID = userData.userUid
    this.userName = userData.name
    this.deviceId = userData.deviceId

    this.prjName = null
    this.zoneSelect = null
    // this.uccZones = null
    this.wardSelect = null
    // this.uccWards = null
    this.addAmount = null
    this.kccZoneSelect = null
    this.kccZones = null
    this.addActive = true
    this.setPermsSuccess = false

    var obj = {
      mob: this.userMobileNo,
      fbid: this.userFBID,
      name: this.userName,
      deviceId: this.deviceId,
    }

    this._ucc.getUccUsers(obj).subscribe((items) => {
      // console.log('Hello WIP', items[0])
      this.jsonData = items[0]
    })
    // kcc
    if (
      this.userData.kcc_permissions == undefined ||
      this.userData.kcc_permissions == null
    ) {
      this.kccZoneActiveStatus = false
      kccZones = []
    } else {
      this.kccZoneActiveStatus = this.userData.kcc_permissions.active
      kccZones = userData.kcc_permissions.zones
    }
    this.kccZones = kccZones

    $('#editPermissionModal').modal('show')
    // $("#ConsumerModal").modal("show");
  }

  onKccPrjSelection() {
    this.http
      .get(
        environment.apiUrl +
          'consumer/getZoneByProject?prjid=' +
          this.kccPrjName +
          '&oemid=7',
      )
      .subscribe((data) => {
        this.kccZoneList = data
      })
  }

  onKccZoneSelect() {
    if (this.kccZoneSelect != null) {
      this.loading = false
    }
    console.log(this.kccZoneSelect)
    var zoneName = this.kccZoneList.filter(
      (item) => item.id == this.kccZoneSelect,
    )
    this.newKccZone = {
      ZONEID: this.kccZoneSelect,
      ZONENAME: zoneName[0].entityname,
    }
  }

  addKccZones() {
    this.kccZones.push(this.newKccZone)
  }

  onPrjSelection() {
    var isPrjActive
    var denominations
    var uccZones

    // ucc
    if (this.prjName == 1) {
      isPrjActive = this.userData.ucc_permissions.LUCKNOW.active
      denominations = this.userData.ucc_permissions.LUCKNOW.denominations
      uccZones = this.userData.ucc_permissions.LUCKNOW.zones
    } else if (this.prjName == 2) {
      isPrjActive = this.userData.ucc_permissions.GURUGRAM.active
      denominations = this.userData.ucc_permissions.GURUGRAM.denominations
      uccZones = this.userData.ucc_permissions.GURUGRAM.zones
    } else if (this.prjName == 3) {
      isPrjActive = this.userData.ucc_permissions.FARIDABAD.active
      denominations = this.userData.ucc_permissions.FARIDABAD.denominations
      uccZones = this.userData.ucc_permissions.FARIDABAD.zones
    } else if (this.prjName == 4) {
      isPrjActive = this.userData.ucc_permissions.GWALIOR.active
      denominations = this.userData.ucc_permissions.GWALIOR.denominations
      uccZones = this.userData.ucc_permissions.GWALIOR.zones
    }
    this.prjActiveStatus = isPrjActive
    this.denominations = denominations
    this.uccZones = uccZones
    this.getZones(this.prjName)

    // var zoneObj = {
    //   ZONEID: this.zoneSelect,
    //   ZONENAME: this.zoneName,
    //   wards: []
    // }

    // if (uccZones.length > 0) {
    //   this.uccZones = uccZones
    // }
    // else {
    //   this.uccZones.push(zoneObj)
    // }

    console.log(uccZones)
  }

  // ucc
  onUccZoneSelect() {
    if (this.zoneSelect != null) {
      this.loading = false
    }
    var zoneName = this.zoneList.filter((item) => item.id == this.zoneSelect)
    this.zoneName = zoneName[0].entityname

    this.http
      .get(
        environment.apiUrl +
          'consumer/getZoneByProject?prjid=' +
          this.newPrjID +
          '&oemid=8&entityid=' +
          this.zoneSelect,
      )
      .subscribe((data) => {
        this.wardList = data
        console.log(this.wardList)
      })

    var zoneObj = {
      // ZONEID: this.zoneSelect,
      ZONEID: this.zoneSelect,
      ZONENAME: '"' + this.zoneName + '"',
      wards: [],
    }

    var uccZones = this.uccZones.filter(
      (item) => item.ZONEID == this.zoneSelect,
    )

    if (this.uccZones.length > 0) {
      // var uccZones = this.uccZones.filter(
      //   (item) => item.ZONEID == this.zoneSelect
      // );
      if (uccZones.length > 0) {
        this.selectedUccZones = uccZones
        this.uccWards = uccZones[0].wards
      } else {
        uccZones.push(zoneObj)
        this.selectedUccZones = uccZones
      }
    } else {
      // this.uccZones.push(zoneObj)
      // this.selectedUccZones = this.uccZones
      uccZones.push(zoneObj)
      this.selectedUccZones = uccZones
    }

    // this.selectedUccZones = uccZones
    // this.uccWards = uccZones[0].wards

    console.log('Wards List', this.uccWards)
  }

  addUccZones() {
    // this.prjName = null
    this.wardSelect = null
    this.setWardSuccess = false

    var zoneObj = { ZONEID: '', ZONENAME: '""', wards: [] }
    zoneObj.ZONEID = this.zoneSelect
    zoneObj.ZONENAME = this.zoneName
    $('#addWards').modal('show')
  }

  onWardSelection() {
    if (this.wardSelect != null) {
      this.loading = false
    }
    var wardname = this.wardList.filter((item) => item.id == this.wardSelect)
    this.wardName = wardname[0].entityname
  }

  removeUser(data) {
    //this.afs.collection('UCC_PERMS').valueChanges;      +919990855895

    this.afs
      .collection('UCC_PERMS')
      .doc(data.mobile)
      .ref.update({ removed: true })

    // this.afs.collection('UCC_PERMS').valueChanges().subscribe( async (val) => {

    //     for (let index = 0; index < val.length; index++) {

    // //      console.log(val[index]['mobile']);

    //       this.afs.collection('UCC_PERMS').doc(val[index]['mobile']).ref.update({'removed':false});

    //     }

    // }
    //)
  }

  addUccWards() {
    var wardsObj = {
      WARDID: '',
      WARDNAME: '',
    }
    wardsObj.WARDID = this.wardSelect
    wardsObj.WARDNAME = '"' + this.wardName + '"'

    // if (this.selectedUccZones[0].wards.length > 0) {
    //   this.uccWards.push(wardsObj)
    // }
    // else {
    //   // this.uccWards = wardsObj
    //   this.uccWards = wardsObj
    // }

    this.uccWards.push(wardsObj)
    this.selectedUccZones[0].wards = this.uccWards
    console.log(this.selectedUccZones)
  }

  removeByAttr(arr, attr, value) {
    var i = arr.length
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1)
      }
    }
    return arr
  }

  addWards() {
    // if(this.uccZones.length == 1, ){

    // }
    this.removeByAttr(this.uccZones, 'ZONEID', this.zoneSelect)
    this.uccZones.push(this.selectedUccZones[0])
    console.log(this.uccZones)
    this.setWardSuccess = true
    setTimeout(() => {
      $('#addWards').modal('hide')
    }, 2000)
  }

  addDenoModel() {
    this.addAmount = null
    this.addActive = null
    this.setDenoSuccess = false
    $('#addDeno').modal('show')
  }
  addDeno() {
    var newDeno = {
      AMOUNT: parseInt(this.addAmount, 10),
      AMT_CODE: this.addAmount,
      active: this.addActive,
    }
    this.denominations.push(newDeno)
    this.setDenoSuccess = true
    setTimeout(() => {
      $('#addDeno').modal('hide')
    }, 2000)
  }

  getZones(zones) {
    this.newPrjID = zones
    this.http
      .get(
        environment.apiUrl +
          'consumer/getZoneByProject?prjid=' +
          zones +
          '&oemid=7',
      )
      .subscribe((data) => {
        this.zoneList = data
      })
  }

  // changeOptions() {
  //   this.editor.destroy();
  //   this.options.mode = this.options.mode == 'tree' ? 'code' : 'tree';
  //   this.editor = new JSONEditor(this.container, this.options);
  //   this.editor.set(JSON.parse(this.strfData));
  // }

  updatePerms() {
    var date = moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
    this.jsonData.updatedDate = date
    this.jsonData.updatedBy = this.wmUser
    // kcc
    this.jsonData.kcc_permissions.active = this.kccZoneActiveStatus
    this.jsonData.kcc_permissions.zones = this.kccZones
    this.jsonData.name = this.userName

    // ucc
    if (this.prjName) {
      if (this.prjName == 1) {
        this.jsonData.ucc_permissions.LUCKNOW.denominations = this.denominations
        this.jsonData.ucc_permissions.LUCKNOW.active = this.prjActiveStatus
        this.jsonData.ucc_permissions.LUCKNOW.zones = this.uccZones
      } else if (this.prjName == 2) {
        this.jsonData.ucc_permissions.GURUGRAM.denominations = this.denominations
        this.jsonData.ucc_permissions.GURUGRAM.active = this.prjActiveStatus
        this.jsonData.ucc_permissions.GURUGRAM.zones = this.uccZones
      } else if (this.prjName == 3) {
        this.jsonData.ucc_permissions.FARIDABAD.denominations = this.denominations
        this.jsonData.ucc_permissions.FARIDABAD.active = this.prjActiveStatus
        this.jsonData.ucc_permissions.FARIDABAD.zones = this.uccZones
      } else if (this.prjName == 4) {
        this.jsonData.ucc_permissions.GWALIOR.denominations = this.denominations
        this.jsonData.ucc_permissions.GWALIOR.active = this.prjActiveStatus
        this.jsonData.ucc_permissions.GWALIOR.zones = this.uccZones
      }
    }
    $('#save-loader').show()

    console.log(this.userMobileNo)

    this.vehMaintDoc = this.afs.collection('UCC_PERMS').doc(this.userMobileNo)
    this.vehMaintDoc.update(this.jsonData)

    this.setPermsSuccess = true
    setTimeout(() => {
      $('#editPermissionModal').modal('hide')
      this.getUccUserReport()
    }, 2000)
    var obj = {
      mob: this.userMobileNo,
      date: date,
      data: this.jsonData,
    }
    this.uccPerms.addUccPermsHistoryDoc(obj)
  }

  /*
   * Update Permission
   */
  // updatePermission() {
  //   var json = this.editor.get();
  //   $("#save-loader").show()
  //   console.log("mobile", json)
  //   this.vehMaintDoc = this.afs.collection('UCC_PERMS').doc(this.userMobileNo);
  //   this.vehMaintDoc.update(json)
  //   $("#save-loader").hide()
  //   this.setclaimSuccess = true
  //   this.refresh();
  //   setTimeout(() => {
  //     $('#editPermissionModal').modal('hide');
  //   }, 3000);
  // }

  // getZone() {
  //   this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid=' + this.prjId + '&oemid=7').subscribe(data => {
  //     this.zoneList = data;
  //     console.log(this.zoneList)

  //   });
  // }

  // getWardByZone(data) {
  //   console.log("getWardByZone", data)
  //   this.http.get(environment.apiUrl + "consumer/getZoneByProject?prjid=" + this.prjId + "&oemid=8&entityid=" + data.id).subscribe(data => {
  //     this.wardList = data;
  //     console.log(this.wardList)
  //   });
  // }

  ngOnInit() {
    this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD')
    // this.container = document.getElementById("jsoneditor");
    // this.options = {};
    // this.editor = new JSONEditor(this.container, this.options);
    this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD')
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.wmUser = this.auth.getAuthentication().userName
    console.log(this.wmUser)

    this.getUccUserReport()
    this.geocoder = new google.maps.Geocoder()
    // this.getZone()
  }
}



// WEBPACK FOOTER //
// ./src/app/superAdmin/users/uccUser.component.ts